import { useEffect, useState } from 'react';

/** True when viewport width is &lt; `maxPx` (Tailwind `md` = 768 → use 768 for “max-md”). */
export function useMaxWidth(maxPx: number): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(`(max-width: ${maxPx - 1}px)`).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxPx - 1}px)`);
    const apply = () => setMatches(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, [maxPx]);

  return matches;
}
